import { capitalize } from "./capitalize";

export function formatString(cargo) {
  const keepLowerCase = [
    "o",
    "os",
    "à",
    "á",
    "a",
    "as",
    "ao",
    "e",
    "de",
    "do",
    "da",
    "dos",
    "das",
    "ante",
    "após",
    "até",
    "com",
    "contra",
    "desde",
    "em",
    "na",
    "no",
    "nas",
    "nos",
    "entre",
    "para",
    "por",
    "perante",
    "sem",
    "sob",
    "sobre",
    "trás",
  ];

  const keepUpperCase = [
    "RIO",
    "VOO",
    "WEB",
    "AUX",
    "ANL",
    "ENG",
    "GTE",
    "AC",
    "AL",
    "AP",
    "AM",
    "BA",
    "CE",
    "DF",
    "ES",
    "GO",
    "MA",
    "MT",
    "MS",
    "MG",
    "PA",
    "PB",
    "PR",
    "PE",
    "PI",
    "RJ",
    "RN",
    "RS",
    "RO",
    "RR",
    "SC",
    "SP",
    "SE",
    "TO",
    "I",
    "II",
    "III",
    "IV",
    "V",
    "VI",
    "VII",
    "VIII",
    "IX",
    "X",
    "SUS",
    "OPME",
    "CFTV",
    "IBGE",
    "CNPJ",
    "SENAC",
    "SENAI",
    "SESI",
    "DP",
    "RH",
    "CRM",
    "PCP",
    "TI",
    "HTML",
    "PHP",
    "ASP",
    "PABX",
    "ABAP",
    "SAP",
    "TIM",
    "DHO",
  ];

  let splitString = cargo.split(" ");
  return splitString
    .map((word) => {
      if (keepLowerCase.includes(word.toLowerCase())) return word.toLowerCase();
      if (keepUpperCase.includes(word)) return word;
      return capitalize(word);
    })
    .join(" ");
}
